import { Outlet, useLocation } from "react-router-dom";
import { ContentSection, Main, Spinner } from "@vwfs-bronson/bronson-react";
import { Header } from "../components/ui/Header";
import { Footer } from "../components/ui/Footer";
import { useAuth } from "../hooks/useAuth";
import { useEffect } from "react";

export const Initializer = () => {
    const { loading } = useAuth();
    let location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);
    return (
        <div className="o-root">
            <Header />
            <Main>
                <ContentSection pageWrap>{loading ? <Spinner fullPage /> : <Outlet />}</ContentSection>
            </Main>
            <Footer />
        </div>
    );
};
